import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, img, useApi, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { UploadButton } from "@/pages/admin/ImageManager";
import { AdminHeader } from "@/pages/admin/AdminLayout";

export default function AdminGallery() {
  const { data, reload } = useApi("/admin/gallery", []);

  const add = async (urls) => {
    const start = data.length;
    await Promise.all(urls.map((u, i) => api.post("/admin/gallery", { image: u, caption: "", order: start + i })));
    reload();
  };
  const update = async (g, patch) => {
    const next = { image: g.image, caption: g.caption, order: g.order, es: g.es || {}, ...patch };
    if (next.caption === g.caption && (next.es.caption || "") === (g.es?.caption || "")) return;
    try {
      await api.put(`/admin/gallery/${g.id}`, next);
      toast.success("Caption saved");
      reload();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  const remove = async (g) => {
    if (!window.confirm("Remove this photo from the gallery?")) return;
    await api.delete(`/admin/gallery/${g.id}`);
    reload();
  };

  return (
    <div data-testid="admin-gallery">
      <AdminHeader title="Gallery">
        <UploadButton multiple onUrls={add} testId="gallery-upload" label="Upload photos" />
      </AdminHeader>
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {data.map((g) => (
          <div key={g.id} className="overflow-hidden rounded-2xl border border-clay bg-white" data-testid={`admin-gallery-item-${g.id}`}>
            <img src={img(g.image)} alt="" className="aspect-[4/3] w-full object-cover" />
            <div className="space-y-2 p-3">
              <div className="flex gap-2">
                <Input defaultValue={g.caption} placeholder="Caption" onBlur={(e) => update(g, { caption: e.target.value })} data-testid={`gallery-caption-${g.id}`} />
                <button onClick={() => remove(g)} className="rounded-lg border border-clay p-2.5 text-moss hover:text-destructive" aria-label="Delete" data-testid={`gallery-delete-${g.id}`}><Trash2 className="h-4 w-4" /></button>
              </div>
              <Input key={g.es?.caption || ""} defaultValue={g.es?.caption || ""} placeholder="Leyenda en español (auto)" onBlur={(e) => update(g, { es: { ...(g.es || {}), caption: e.target.value } })} data-testid={`gallery-caption-es-${g.id}`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
